import styled from 'styled-components'

export const FormContainer = styled.form`
  display: flex;
  height: 60px;
`

export const FormFooter = styled.div`
  margin-top: 5px;
  text-align: right;
`

export const InputMessage = styled.input`
  width: 100%;
  padding: 0 10px;
  border-radius: 3px 0 0 3px;
  outline: none;
  border: none;
`

export const Button = styled.button`
  outline: none;
  border: none;
  background: black;
  color: white;
  border-radius: 0 3px 3px 0;
  cursor: pointer;
`
